export var RepeatAlarm;
(function (RepeatAlarm) {
    RepeatAlarm[RepeatAlarm["AlarmRepeatUntilResolved"] = 1] = "AlarmRepeatUntilResolved";
    RepeatAlarm[RepeatAlarm["AlaramRepeats3Times"] = 2] = "AlaramRepeats3Times";
    RepeatAlarm[RepeatAlarm["NoRepeat"] = 3] = "NoRepeat";
})(RepeatAlarm || (RepeatAlarm = {}));
export var AlertType;
(function (AlertType) {
    AlertType[AlertType["EmailAndSMS"] = 1] = "EmailAndSMS";
    AlertType[AlertType["EmailOnly"] = 2] = "EmailOnly";
    AlertType[AlertType["SMSOnly"] = 3] = "SMSOnly";
})(AlertType || (AlertType = {}));
export var NodeBehaviour;
(function (NodeBehaviour) {
    NodeBehaviour[NodeBehaviour["Normal"] = 0] = "Normal";
    NodeBehaviour[NodeBehaviour["NoNodeCommunication"] = 1] = "NoNodeCommunication";
})(NodeBehaviour || (NodeBehaviour = {}));
